import React from "react";

import RankCategory from "../../components/RankCategory";
import "./index.css";

const AboutUs = () => {
  // ========================================
  // RANKS PAGE - MAIN DATA STRUCTURE
  // ========================================
  // This is the main data structure for all rank categories and individual ranks
  //
  // TO ADD A NEW RANK CATEGORY:
  // 1. Add a new object to the rankCategories array below
  // 2. Include: title, description, and ranks array
  // 3. Each rank needs: icon, title, tag (optional), description
  //
  // TO ADD A NEW RANK TO EXISTING CATEGORY:
  // 1. Find the category in the rankCategories array
  // 2. Add a new rank object to the ranks array
  // 3. Include: icon, title, tag (optional), description
  //
  // TO CHANGE RANK INFORMATION:
  // 1. Find the rank in the appropriate category
  // 2. Update the icon, title, tag, or description
  // 3. Save the file to see changes
  //
  // TAG SYSTEM:
  // - Staff role: Orange background (#ebae46) - for command positions
  // - Veteran: Teal background (#8db1a1) - for experienced personnel
  // - Recruit: Gray background (#999999) - for new members
  // - No tag: Some ranks don't have tags (like Senior Non-commissioned Officers)

  // Rank categories data
  const rankCategories = [
    {
      title: "[O-8] Major General Hombrger", 
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Regimental Commanding Officer",
        },
        {
          title: "Department(s)",
          description:
            "Head Of WT, HD2, Enlisted, And Logistics",
        },
        {
          title: "Joined Server",
          description:
            "22nd March 2025",
        },
        {
          title: "Joined Corps",
          description:
            "22nd March 2025",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-7] Brigadier General 'Kim' Kenobi",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Regimental Executive Officer",
        },
        {
          title: "Department(s)",
          description:
            "Head Of Squad And Assistant Head Of HD2",
        },
        {
          title: "Joined Server",
          description:
            "7th January 2026",
        },
        {
          title: "Joined Corps",
          description:
            "14th January 2026",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-6] Colonel Connie",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Regimental Operations + Affairs Officer",
        },
        {
          title: "Department(s)",
          description:
            "Head Of Media And Assistant Head Of Battlefield",
        },
        {
          title: "Joined Server",
          description:
            "26th November 2025",
        },
        {
          title: "Joined Corps",
          description:
            "29th November 2025",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ELOA - [CLASSIFIED]",
        },
      ],
    },
    {
      title: "[O-6] Colonel Curry",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Regimental Finance + Intelligence Officer",
        },
        {
          title: "Department(s)",
          description:
            "Assisting Staff Of Logistics, Media, And HD2",
        },
        {
          title: "Joined Server",
          description:
            "17th December 2025",
        },
        {
          title: "Joined Corps",
          description:
            "30th December 2025",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-5] Lieutenant Colonel Yukki",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Battalion I Commanding Officer",
        },
        {
          title: "Department(s)",
          description:
            "Assistant Head For HD2",
        },
        {
          title: "Joined Server",
          description:
            "23rd September 2025",
        },
        {
          title: "Joined Corps",
          description:
            "22nd November 2025",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },  
    {
      title: "[O-4] Major SpaceBalls",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Battalion I Executive Officer",
        },
        {
          title: "Department(s)",
          description:
            "Assistant Head Of Enlisted",
        },
        {
          title: "Joined Server",
          description:
            "1st September 2025",
        },
        {
          title: "Joined Corps",
          description:
            "18th September 2025",
        },
        {
          title: "Region",
          description:
            "NAC",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    }, 
    {
      title: "[O-4] Major Dedsec",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Reservist",
        },
        {
          title: "Department(s)",
          description:
            "Assistant Head For Logistics And Assisting Staff For Battlefield",
        },
        {
          title: "Joined Server",
          description:
            "21st November 2025",
        },
        {
          title: "Joined Corps",
          description:
            "22nd November 2025",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "E-LOA [CLASSIFIED]",
        },
      ],
    },   
    {
      title: "[O-3] Captain Alex",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company I Commanding Office",
        },
        {
          title: "Department(s)",
          description:
            "Assistant Head Of Hell Let Loose",
        },
        {
          title: "Joined Server",
          description:
            "25th March 2025",
        },
        {
          title: "Joined Corps",
          description:
            "25th March 2025",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-3] Captain Gatto",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company II Commanding Officer",
        },
        {
          title: "Department(s)",
          description:
            "Head Of Hell Let Loose",
        },
        {
          title: "Joined Server",
          description:
            "27th September 2025",
        },
        {
          title: "Joined Corps",
          description:
            "22nd November 2025",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-2] First Lieutenant Massa",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company I Staff",
        },
        {
          title: "Department(s)",
          description:
            "Head Of Battlefield",
        },
        {
          title: "Joined Server",
          description:
            "24th March 2025",
        },
        {
          title: "Joined Corps",
          description:
            "24th March 2025",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant SkeletonPilot",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company I Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assisting Staff For Enlisted and War Thunder",
        },
        {
          title: "Joined Server",
          description:
            "19th December 2025",
        },
        {
          title: "Joined Corps",
          description:
            "19th April 2026",
        },
        {
          title: "Region",
          description:
            "EU",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant Mizer",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company I Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assisting Staff For Hell Let Loose",
        },
        {
          title: "Joined Server",
          description:
            "15th December 2025",
        },
        {
          title: "Joined Corps",
          description:
            "21st March 2026",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant Eli",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company II Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assisting Staff For Enlisted",
        },
        {
          title: "Joined Server",
          description:
            "5th January 2026",
        },
        {
          title: "Joined Corps",
          description:
            "14th May 2026",
        },
        {
          title: "Region",
          description:
            "NAW",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant X2Hello",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company II Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assisting Staff For Squad",
        },
        {
          title: "Joined Server",
          description:
            "2nd May 2026",
        },
        {
          title: "Joined Corps",
          description:
            "17th May 2026",
        },
        {
          title: "Region",
          description:
            "NAE",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant NotSoSimple",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company II Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assiting Staff For Enlisted",
        },
        {
          title: "Joined Server",
          description:
            "8th June 2026",
        },
        {
          title: "Joined Corps",
          description:
            "9th July 2026",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "[O-1] Second Lieutenant Hammad-19",
      description:
        "",
      ranks: [
        {
          title: "Position",
          description:
            "Company II Staff",
        },
        {
          title: "Department(s)",
          description:
            "Assiting Staff For Squad",
        },
        {
          title: "Joined Server",
          description:
            "22nd May 2026",
        },
        {
          title: "Joined Corps",
          description:
            "31st May 2026",
        },
        {
          title: "Region",
          description:
            "ASIA",
        },
        {
          title: "Status",
          description:
            "ACTIVE",
        },
      ],
    },
    {
      title: "Voices Of The Regiment",
      description:
        "",
      ranks: [
        {
          title: "[O-8] MajGen Hombrger",
          description:
            "I created this server with a clear vision. Create a community, where people from all over the world can come together, and play whenever, however, and with whoever. As someone whos been in numerous milsims, I didn't want to have a server where I had to follow and create a bunch of strict rules. I just wanted a place I could make friends, and play whenever I want. I would say I succeeded in that matter, and this is by far, my best creation, and I am so proud of who we are today. Not only are we a discord server, we are a family of friends  ",
        },
        {
          title: "[O-7] BGen Kenobi",
          description:
            "I’m kWNBe, also known as Kenobi. I'm a Finnish gamer with over 20 years of experience across a wide range of communities. I enjoy bringing positivity, strategy, and calm communication to any team. Outside of gaming, I study engineering and work in tech, which keeps me involved with programming, networking, and digital systems. In games I analyze mechanics, test builds, and value fairness, teamwork, and a good challenge, whether it’s PvP, PvE, or sandbox play. If you ever want to theorycraft, run missions, or just talk tech and gaming, I’m always up for it.",
        },
        {
          title: "[O-6] Col Connie",
          description:
            "From day one when i joined the community i had a purpose and it is to get the 5th Marine Regiment as popular as we can day by day. I coordinate and manage many subjects and duties along side my fellow Senior Command Officers, Myself i play many games but mostly Helldivers 2, Ready Or Not, CS2 and many other games. With our community members as we grow all together we have become a family of the 5th Marine Regiment; my second home.",
        },
        {
          title: "[O-6] Col Curry",
          description:
            "I've Been part of 5th Marine Regiment for almost a year now, and it’s been an absolute blast. You’ll mostly find me lurking in VC, dropping bad jokes and stirring up chaos. I love being around for the laughs, the random stories, and the occasional “motivational” rant that somehow keeps people logging back in. When I’m not pretending to be a serious officer, I’m usually playing Escape from Tarkov, Among Us, or Hell Divers 2 with the crew. Always happy to chat, mess around, or just be an extra body when things kick off.",
        },
        {
          title: "[O-5] LtCol Yukki",
          description:
            "I’ve been on of the server for quite some time now, and am always active especially in voice chats. I usually play Helldivers 2 and alot of racing games like Asseto Corsa and BeamNg Drive. I'm quite active during our game nights and like to play with members of the community and you’ll often see me in the voice chats. I became an officer in late November 2025 now and has been great, and I enjoy supporting the server and all of our members and I’m happy to help and get involved whenever it is needed.",
        },
        {
          title: "[O-4] Maj Spaceball",
          description:
            "I joined the 5th looking for a place to call home and I was also looking for a community that would welcome a casual enlisted player. I would say after the very warm welcome I received and kindness throughout my stay, I would have to say both of those things were fulfilled, I joined back when it was a small community of about 150-200 people, and watching it grow as both an officer in the Corps and as a regular member brought me joy. Enlisted drew me into the server but the kindness and respect of the other members and officers made me stay and become a better person, both online and in my day to day interactions with others.",
        },
        {
          title: "[O-3] Cat Gatto",
          description:
            "I have been part of the server for a couple months now. I usually play titles including Hell Let Loose and Occasionally Helldivers 2.  So far my experience with the community and the rest of staff for the server has been great and mostly fluid. Finally I have made some great friends and unforgettable moments",
        },
        {
          title: "[O-2] 1Lt Massa",
          description:
            "Howdy, I am Massa and ive been around for a year in the 5th Marine Regiment. I was just a regular member but soon i took the role of an officer and climbed up the ranks, I am fairly active and i engage in activities. I love the fifth marines and I want to stay here, And I will. I have met very cool people and the officer corps has a truly a special place in my heart, Joining this server is the best thing you could do.",
        },
        {
          title: "[CW-4] CWO4 LandoSnow",
          description:
            "I’ve been part of the server for a while now in the community. I mainly HLL and Helldivers with the community, and you’ll often see me in the chats or helping out when I can. Becoming an officer has been enjoyable and to help the community is the reason i stand with this server. Its such an enjoyable place to be. I can't begin to explain how many things i've learned, and how many friends i've made.",
        },
        {
          title: "[CW-5] CWO5 Alysius",
          description:
            "I’m Alysius, an officer in the 5th Marine Regiment server and a Helldivers 2 player who loves teaming up, helping others, and keeping things fun for everyone. As an active member of this growing community, I take pride in supporting squadmates, maintaining a friendly and respectful environment, and finding real solace in the shared challenges, victories, and stories we create together.",
        },
        
      ],
    },
  ];

  // ========================================
  // PAGE LAYOUT - EDIT TITLES AND CONTENT HERE
  // ========================================
  // This section controls how the page looks and what content appears
  //
  // TO CHANGE THE PAGE TITLE:
  // - Change "Ranks" to whatever you want
  //
  // TO CHANGE THE INFO CARD:
  // - Update the image src, title, and text content below
  // - The image should be in the public/images/ folder
  //
  // TO CHANGE RANK CATEGORIES:
  // - Edit the rankCategories array above
  // - The categories will automatically display in the order they appear in the array

  return (
    <div className="ranks-page">
      <div className="ranks-container">
        {/* PAGE TITLE - Change this text to update the main heading */}
        <h1 className="ranks-title">About Us</h1>

        {/* RANKS INFORMATION CARD - Edit this section to update the intro content */}
        <div className="ranks-info-card">
          <div className="ranks-card-image">
            {/* INFO CARD IMAGE - Change src to use a different image */}
            <img
              src="/images/Battlefield-6-homepage3.jpg"
              alt="Military personnel in tactical gear"
              className="ranks-image"
            />
          </div>
          <div className="ranks-card-content">
            {/* INFO CARD TITLE - Change this text */}
            <h2 className="ranks-card-title">
              The 5th Marine Regiment. Who Are We?
            </h2>
            {/* INFO CARD TEXT - Change these paragraphs */}
            <p className="ranks-card-text">
              Some think we are a milsim. Others think we are a clan. In reality, we are neither. We are a family of gamers from all around the world, from all ages. Were proud to say that we have peoples own parents within the server! 
              We know life is unfair, and people can get called up to work when all they want to do is game (I mean who doesn't). Thats where we differ from other servers. Chances are, in many other servers, if your inactive, you get the boot 
              out the server. We know what its like to have random stuff thrown onto you. If your inactive, we dont care! We just want to host a place, where people can hop on once in a while, and relax. Its dead simple
            </p>
            <p className="ranks-card-text">
              So why should you join us? Good question. At the end of the day, its entirely up to you, however, we offer: 1 Squad Server, 1 Hell Let Loose Server, a chance to always have a squadmates, players on each night, 24/7 staff coverage, our own discord bot with custom commands to keep you hinged in the server, 0 activity requirements, and weekly events, giveaways, and more!
            </p>
            <p className="ranks-card-text">
              Below, is our entire staff list, with everyones jobs and duties, to ensure the server is a safe space for you. A few staff members have also left a little message
              for you to read, about their life in the server, which can be found at the very bottom of this page
            </p>
          </div>
        </div>

        {/* RANK CATEGORIES - Automatically displays all categories from rankCategories array */}
        <div className="ranks-categories">
          {rankCategories.map((category, index) => (
            <RankCategory
              key={index}
              title={category.title}
              description={category.description}
              ranks={category.ranks}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
